import { DialogComponent, DialogModel } from "@syncfusion/ej2-react-popups";
import { dialogStore } from "./stores/DialogStore";
import classNames from "classnames";
import { DefaultHtmlAttributes } from "@syncfusion/ej2-react-base";
import { isUndefined, omit } from "lodash";

type DialogComponentProps = DialogModel & DefaultHtmlAttributes;
export type DialogProps = {
  id: string;
  className?: string;
  width?: string;
  parentDialogId?: string;
  header?: string | (() => React.ReactNode);
  content?: () => React.ReactNode;
  close?: () => void;
  isFullScreen?: boolean;
} & Omit<
  DialogComponentProps,
  "isModal" | "visible" | "content" | "footerTemplate" | "header"
>;

const Dialog: React.FC<DialogProps> = (props) => {
  return (
    <div
      className={classNames("ucl-dialog-container", props.className)}
      id={props.id}
    >
      <DialogComponent
        cssClass={classNames("ucl-dialog", {
          "ucl-dialog-full-screen": props.isFullScreen,
        })}
        width={props.isFullScreen ? undefined : props.width || "50%"}
        visible={true}
        target={`#${props.id}`}
        isModal={true}
        showCloseIcon={
          isUndefined(props.showCloseIcon) ? true : props.showCloseIcon
        }
        closeOnEscape={
          isUndefined(props.closeOnEscape) ? true : props.closeOnEscape
        }
        allowDragging={
          isUndefined(props.allowDragging) ? false : props.allowDragging
        }
        close={() =>
          props.close ? props.close() : dialogStore.closeDialog(props.id)
        }
        {...omit(props, "content")}
      >
        {props.content && props.content()}
        <div className="ucl-dialog-footer-block"></div>
      </DialogComponent>
      {/* <div className="ucl-dialog-footer-block"></div> */}
    </div>
  );
};

export default Dialog;
